import { Component, Input, OnInit, Optional } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormComponent } from '../form.components';

export type OptionCheckboxItem = {
  label: string;
  value: any;
};

@Component({
  selector: 'hospitality-bot-option-checkbox-group',
  templateUrl: './option-checkbox-group.component.html',
  styleUrls: ['./option-checkbox-group.component.scss'],
})
export class OptionCheckboxGroupComponent
  extends FormComponent
  implements OnInit {
  checkboxOptions: OptionCheckboxItem[] = [
    { label: 'Exclusive', value: false },
    { label: 'Inclusive', value: true },
  ];

  constructor(@Optional() public controlContainer: ControlContainer) {
    super(controlContainer);
  }

  ngOnInit(): void {
    if (this.controlName && this.controlContainer?.control) {
      this.initInputControl();
    }
  }

  isSelected(option: OptionCheckboxItem): boolean {
    return this.inputControl?.value === option.value;
  }

  get isGroupDisabled(): boolean {
    return this.isDisabled || !!this.inputControl?.disabled;
  }

  select(option: OptionCheckboxItem): void {
    if (this.isGroupDisabled) return;
    this.inputControl?.setValue(option.value);
    this.inputControl?.markAsDirty();
    this.inputControl?.markAsTouched();
  }
}
